/* feela. SEAT v2 — 「30秒で硬さチェック」→ AI硬さアドバイザー（2026-08-29 最下部配置版）
   LP最下部（FAQの直後・購入エリアの直前）に配置し、店員と会話しているような
   チャット形式で6問に回答してもらい、結果を直下の既存購入エリアへ連携する。
   全画面化・モーダル化・別ページ遷移・スクロールロックはしない。
   点数化・体重変換・境界(60/89/90)・硬め好き補正は、本番稼働中の既存診断
   snippets/fl-onepage-diagnosis.liquid の calcResult と同じ計算式をここで再実装している
   （ロジックの正本は既存診断コード。質問6の文言だけ医療表現を避けて変更、点数は同一）。
   IntersectionObserver・requestAnimationFrameの継続ループ・window の scroll/resize
   リスナーは追加しない。チャット内の自動スクロールは要素自身の scrollTop のみで行う。
   ルートごとに初期化ガードし、shopify:section:load 後も二重初期化しない。 */
(function () {
  'use strict';

  if (window.__fsvFirmnessCheckInitialized) return;
  window.__fsvFirmnessCheckInitialized = true;

  var QUESTIONS = [
    {
      id: 'weight',
      text: '体重の目安は？',
      scoreMode: 'raw',
      options: [
        { value: 48, label: '〜50kg' },
        { value: 55, label: '51〜60kg' },
        { value: 65, label: '61〜70kg' },
        { value: 75, label: '71〜80kg' },
        { value: 83, label: '81〜100kg' },
        { value: 100, label: '100kg〜' }
      ]
    },
    {
      id: 'preference',
      text: '普段の座り心地の好みは？',
      options: [
        { value: 'soft', label: '柔らかめが好き', score: -10 },
        { value: 'medium', label: '普通・わからない', score: 0 },
        { value: 'hard', label: '硬めが好き', score: 10 }
      ]
    },
    {
      id: 'pressure',
      text: 'お尻への圧迫感は気になりやすいですか？',
      options: [
        { value: 'concerned', label: '気になる', score: -10 },
        { value: 'none', label: '特に気にならない', score: 0 }
      ]
    },
    {
      id: 'usage',
      text: '主な使用シーンは？',
      options: [
        { value: 'デスクワーク', label: 'デスクワーク', score: 10 },
        { value: '運転・移動', label: '運転・長時間移動', score: 5 },
        { value: '自宅でリラックス', label: '自宅でのリラックス', score: -10 },
        { value: '介護用', label: 'ご家族のケア・介護での使用', score: -10 }
      ]
    },
    {
      id: 'age',
      text: '年代は？',
      options: [
        { value: 'young', label: '〜59歳', score: 0 },
        { value: 'middle', label: '60〜74歳', score: -5 },
        { value: 'senior', label: '75歳〜', score: -10 }
      ]
    },
    {
      id: 'worry',
      text: '座るとき、特に重視したいことは？',
      options: [
        { value: 'お尻まわりへのやさしい当たり', label: 'お尻まわりへのやさしい当たり', score: -10 },
        { value: '腰まわりの支え感', label: '腰まわりの支え感', score: 5 },
        { value: '沈み込みすぎないこと', label: '沈み込みすぎないこと', score: 10 },
        { value: '特になし', label: '特になし', score: 0 }
      ]
    }
  ];

  var TIER_INFO = {
    soft: { name: 'ソフト', desc: 'ふんわり沈む、やさしい座り心地。', weight: '体重35〜60kg目安' },
    medium: { name: 'ミディアム', desc: 'ほどよく沈む、しっかりした座り心地。', weight: '体重45〜85kg目安' },
    hard: { name: 'ハード', desc: '沈み込みを抑えた、安定感のある座り心地。', weight: '体重75〜110kg目安' }
  };

  var USAGE_RECO = {
    'デスクワーク': 'デスクワークで長く座る方へ。',
    '運転・移動': '運転や長時間移動で使う方へ。',
    '自宅でリラックス': '自宅でくつろぐ時間に使う方へ。',
    '介護用': 'ご家族のケアで使う方へ。'
  };

  var ANALYZING_LINES = [
    '体格データを確認しています…',
    '座り心地の好みを整理しています…',
    '使用シーンに合う硬さを確認しています…',
    'おすすめの硬さをご案内します。'
  ];

  var ADVISOR_SVG =
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">' +
    '<path d="M12 3l2.2 4.6L19 9l-4.8 1.4L12 15l-2.2-4.6L5 9l4.8-1.4L12 3z"/>' +
    '<path d="M5 18l1 2 2 1-2 1-1 2-1-2-2-1 2-1 1-2z"/>' +
    '</svg>';

  var CHECK_SVG =
    '<svg class="feela-seat-v2-fc__answer-check" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M4 12l5 5L20 6"/></svg>';

  function prefersReducedMotion() {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }

  function focusWithoutScroll(el) {
    if (!el) return;
    var x = window.scrollX;
    var y = window.scrollY;
    try {
      el.focus({ preventScroll: true });
    } catch (e) {
      el.focus();
    }
    if (window.scrollX !== x || window.scrollY !== y) {
      window.scrollTo(x, y);
    }
  }

  function calcTier(answers) {
    var total = 0;
    QUESTIONS.forEach(function (q) {
      var a = answers[q.id];
      if (!a) return;
      total += q.scoreMode === 'raw' ? a.value : a.score;
    });
    var tier = total <= 60 ? 'soft' : total <= 89 ? 'medium' : 'hard';
    if (tier === 'soft' && answers.preference && answers.preference.score === 10) tier = 'medium';
    if (tier === 'soft' && answers.worry && answers.worry.score === 10) tier = 'medium';
    return tier;
  }

  function buildRecommendation(answers) {
    var usageVal = answers.usage ? answers.usage.value : 'デスクワーク';
    return USAGE_RECO[usageVal] || 'いつもの場面で使う方へ。';
  }

  /* 2026-08-29: 既存の購入エリア（feela-seat-purchase）が持つ variant 一覧を
     「読むだけ」で、診断側に新しいvariant管理は作らない。カラーなど硬さ以外の
     現在選択はそのまま維持し、硬さだけをおすすめ値に置き換えて一致するvariantの
     在庫有無を調べる。一致するvariantが見つからない場合は判定不能として
     in-stock 扱い（購入エリア側の表示を優先させ、誤った警告は出さない）。 */
  function checkAvailability(tier) {
    var purchase = document.querySelector('feela-seat-purchase');
    if (!purchase) return { determined: false, available: true };
    var variantsScript = purchase.querySelector('[data-fsv-variants]');
    if (!variantsScript) return { determined: false, available: true };

    var variants;
    try {
      variants = JSON.parse(variantsScript.textContent);
    } catch (e) {
      return { determined: false, available: true };
    }

    var keywordMap = { soft: 'ソフト', medium: 'ミディアム', hard: 'ハード' };
    var keyword = keywordMap[tier];
    var inputs = Array.prototype.slice.call(purchase.querySelectorAll('input[type="radio"]'));
    var hardnessInput = inputs.filter(function (r) {
      return r.dataset.optionName === '硬さ' && r.value.indexOf(keyword) === 0;
    })[0];
    if (!hardnessInput) return { determined: false, available: true };

    var selected = {};
    inputs.forEach(function (r) {
      if (r.checked) selected[r.dataset.optionName] = r.value;
    });
    selected['硬さ'] = hardnessInput.value;

    var variant = variants.filter(function (v) {
      return Object.keys(selected).every(function (name) { return v.options[name] === selected[name]; });
    })[0];

    if (!variant) return { determined: false, available: true };
    return { determined: true, available: !!variant.available };
  }

  /* 2026-08-29 修正: 結果が確定した瞬間に1回だけ呼ぶ。硬さラジオの選択とchange
     イベント発火・一度だけの強調（fsv-hardness-flash）だけを行う。カラーには触れない。
     スクロール・フォーカスはここでは行わない（ボタン側の役割に分離した）。 */
  function applyTierToPurchase(tier) {
    var purchase = document.querySelector('feela-seat-purchase');
    if (!purchase) return;
    var keywordMap = { soft: 'ソフト', medium: 'ミディアム', hard: 'ハード' };
    var keyword = keywordMap[tier];
    var radio = Array.prototype.slice.call(purchase.querySelectorAll('input[type="radio"]')).filter(function (r) {
      return r.dataset.optionName === '硬さ' && r.value.indexOf(keyword) === 0;
    })[0];
    if (!radio) return;

    if (!radio.checked) {
      radio.checked = true;
      radio.dispatchEvent(new Event('change', { bubbles: true }));
    }

    /* 購入エリアの「一度だけの弱い強調」は、モーダル選択時と同じ既存の
       .fsv-hardness-flash をそのまま使う（重複するアニメーション定義は持たない）。
       結果確定のたびに1回だけ発火させる（すでに同じ値でも確認の合図として発火する）。 */
    var option = radio.closest('.feela-seat-v2-purchase__option');
    if (option) {
      option.classList.remove('fsv-hardness-flash');
      void option.offsetWidth;
      option.classList.add('fsv-hardness-flash');
      option.addEventListener(
        'animationend',
        function () {
          option.classList.remove('fsv-hardness-flash');
        },
        { once: true }
      );
    }
  }

  /* 2026-08-29 修正: 「おすすめの硬さで注文内容を確認する」ボタンの役割はこれだけ。
     硬さの選択・変更イベントの発火は一切行わない（結果確定時にすでに反映済み）。 */
  function scrollToPurchaseAndFocus() {
    var purchaseSection = document.getElementById('feela-seat-v2-purchase');
    if (purchaseSection) {
      purchaseSection.scrollIntoView({ behavior: prefersReducedMotion() ? 'auto' : 'smooth', block: 'start' });
    }

    var heading = document.getElementById('fsv-purchase-title');
    if (heading) {
      if (!heading.hasAttribute('tabindex')) heading.setAttribute('tabindex', '-1');
      focusWithoutScroll(heading);
    }
  }

  function initRoot(root) {
    if (root.dataset.fsvFcInitialized === 'true') return;
    root.dataset.fsvFcInitialized = 'true';

    var stage = root.querySelector('[data-fsv-fc-stage]');
    var fallback = root.querySelector('[data-fsv-fc-fallback]');
    if (!stage) return;

    var timers = [];
    function setTimer(fn, ms) {
      var id = setTimeout(fn, ms);
      timers.push(id);
      return id;
    }
    function clearTimers() {
      timers.forEach(function (id) { clearTimeout(id); });
      timers.length = 0;
    }

    var answers = {};
    var stepIndex = 0;
    var typingLock = false;
    var chatLog = null;
    var actionSlot = null;

    function clear(el) {
      while (el.firstChild) el.removeChild(el.firstChild);
    }

    function button(cls, text, attrs) {
      var b = document.createElement('button');
      b.type = 'button';
      if (cls) b.className = cls;
      if (text != null) b.textContent = text;
      if (attrs) {
        Object.keys(attrs).forEach(function (k) { b.setAttribute(k, attrs[k]); });
      }
      return b;
    }

    function scrollLogToBottom() {
      if (chatLog) chatLog.scrollTop = chatLog.scrollHeight;
    }

    /* ---- タイプライター：視覚部分は aria-hidden、読み上げ用の完成文は
       別要素へ1回だけ入れる（1文字ずつは読み上げさせない） ---- */
    function typeInto(el, text, done) {
      if (prefersReducedMotion()) {
        el.textContent = text;
        if (done) done();
        return;
      }
      var len = text.length || 1;
      var totalMs = Math.min(900, Math.max(200, len * 22));
      var stepMs = Math.max(12, totalMs / len);
      var i = 0;
      el.textContent = '';
      function step() {
        i++;
        el.textContent = text.slice(0, i);
        scrollLogToBottom();
        if (i < text.length) {
          setTimer(step, stepMs);
        } else if (done) {
          done();
        }
      }
      setTimer(step, stepMs);
    }

    /* 読み上げ用の完成文を1個だけ作る。末尾がすでに句点・疑問符・感嘆符の場合は
       「。」を重ねず半角スペースでつなぐ（「？。」のような重複を避けるため）。 */
    function joinForSpeech(mainText, sub) {
      if (!sub) return mainText;
      var lastChar = mainText.charAt(mainText.length - 1);
      var joiner = (lastChar === '。' || lastChar === '？' || lastChar === '！') ? ' ' : '。';
      return mainText + joiner + sub;
    }

    function appendAiMessage(mainText, opts) {
      opts = opts || {};
      var row = document.createElement('div');
      row.className = 'feela-seat-v2-fc__msg feela-seat-v2-fc__msg--ai';
      if (opts.step != null) row.setAttribute('data-fsv-fc-step', String(opts.step));

      var avatar = document.createElement('span');
      avatar.className = 'feela-seat-v2-fc__msg-avatar';
      avatar.setAttribute('aria-hidden', 'true');
      avatar.innerHTML = ADVISOR_SVG;
      row.appendChild(avatar);

      var bubble = document.createElement('div');
      bubble.className = 'feela-seat-v2-fc__bubble';

      /* 2026-08-29 修正: 分析メッセージ（instant指定）とreduced motion時は、
         タイプライターを使わず完成文をそのまま1つの要素に入れる。
         読み上げ用の別要素を重ねないため、二重通知にはならない。 */
      if (opts.instant || prefersReducedMotion()) {
        var plain = document.createElement('p');
        plain.className = 'feela-seat-v2-fc__bubble-text';
        plain.textContent = mainText;
        bubble.appendChild(plain);
        if (opts.sub) {
          var plainSub = document.createElement('p');
          plainSub.className = 'feela-seat-v2-fc__bubble-sub';
          plainSub.textContent = opts.sub;
          bubble.appendChild(plainSub);
        }
        row.appendChild(bubble);
        chatLog.appendChild(row);
        scrollLogToBottom();
        if (opts.onDone) opts.onDone(row, bubble);
        return row;
      }

      var visible = document.createElement('p');
      visible.className = 'feela-seat-v2-fc__bubble-text';
      visible.setAttribute('aria-hidden', 'true');
      bubble.appendChild(visible);

      var subEl = null;
      if (opts.sub) {
        subEl = document.createElement('p');
        subEl.className = 'feela-seat-v2-fc__bubble-sub';
        subEl.setAttribute('aria-hidden', 'true');
        subEl.hidden = true;
        subEl.textContent = opts.sub;
        bubble.appendChild(subEl);
      }

      var srOnly = document.createElement('span');
      srOnly.className = 'feela-seat-v2-visually-hidden';
      srOnly.textContent = joinForSpeech(mainText, opts.sub);
      bubble.appendChild(srOnly);

      row.appendChild(bubble);
      chatLog.appendChild(row);
      scrollLogToBottom();

      typingLock = true;
      typeInto(visible, mainText, function () {
        if (subEl) subEl.hidden = false;
        typingLock = false;
        scrollLogToBottom();
        if (opts.onDone) opts.onDone(row, bubble);
      });
      return row;
    }

    function appendUserMessage(text, step) {
      var row = document.createElement('div');
      row.className = 'feela-seat-v2-fc__msg feela-seat-v2-fc__msg--user';
      if (step != null) row.setAttribute('data-fsv-fc-step', String(step));
      var bubble = document.createElement('div');
      bubble.className = 'feela-seat-v2-fc__bubble';
      bubble.textContent = text;
      row.appendChild(bubble);
      chatLog.appendChild(row);
      scrollLogToBottom();
      return row;
    }

    function removeStepsFrom(step) {
      Array.prototype.slice.call(chatLog.querySelectorAll('[data-fsv-fc-step]')).forEach(function (node) {
        var s = parseInt(node.getAttribute('data-fsv-fc-step'), 10);
        if (s >= step && node.parentNode) node.parentNode.removeChild(node);
      });
    }

    function buildHeader() {
      var header = document.createElement('div');
      header.className = 'feela-seat-v2-fc__header';
      var avatar = document.createElement('span');
      avatar.className = 'feela-seat-v2-fc__header-avatar';
      avatar.setAttribute('aria-hidden', 'true');
      avatar.innerHTML = ADVISOR_SVG;
      var name = document.createElement('span');
      name.className = 'feela-seat-v2-fc__header-name';
      /* 画面上は feela の部分だけ色分けする。読み上げ内容は
         textContentが自然に連結する「feela. AI硬さアドバイザー」のまま変わらない。
         挿入するのは固定文字列のみで、回答やユーザー入力・外部データは一切含まない。 */
      var flFeela = document.createElement('span');
      flFeela.className = 'fl-feela';
      flFeela.appendChild(document.createTextNode('feela'));
      var dot = document.createElement('span');
      dot.className = 'dot';
      dot.textContent = '.';
      flFeela.appendChild(dot);
      name.appendChild(flFeela);
      name.appendChild(document.createTextNode(' AI硬さアドバイザー'));
      header.appendChild(avatar);
      header.appendChild(name);
      return header;
    }

    function buildShell() {
      clearTimers();
      typingLock = false;
      clear(stage);

      stage.appendChild(buildHeader());

      var log = document.createElement('div');
      log.className = 'feela-seat-v2-fc__log';
      log.setAttribute('role', 'log');
      log.setAttribute('aria-live', 'polite');
      log.setAttribute('aria-label', 'feela. AI硬さアドバイザーとの会話');
      stage.appendChild(log);
      chatLog = log;

      var actions = document.createElement('div');
      actions.className = 'feela-seat-v2-fc__actions';
      stage.appendChild(actions);
      actionSlot = actions;
    }

    /* ---- スタート（会話ログの最初のAI発言として表示） ---- */
    function renderStart() {
      answers = {};
      stepIndex = 0;
      buildShell();

      appendAiMessage('いらっしゃいませ。硬さ選びをお手伝いします。6つだけ質問してもよろしいですか？', {
        sub: '約30秒で、硬さの目安をご案内します。'
      });
      renderStartActions();
    }

    function renderStartActions() {
      clear(actionSlot);
      var startBtn = button('feela-seat-v2__btn feela-seat-v2__btn--primary feela-seat-v2-fc__start-btn', '相談を始める');
      startBtn.addEventListener('click', function () {
        if (typingLock) return;
        beginChat();
      });
      actionSlot.appendChild(startBtn);

      var skip = document.createElement('p');
      skip.className = 'feela-seat-v2-fc__skip';
      skip.textContent = '相談しなくても、そのまま商品をお選びいただけます。';
      actionSlot.appendChild(skip);
    }

    function beginChat() {
      clear(actionSlot);
      askQuestion(0);
    }

    /* ---- 質問（ログへ追加） ---- */
    function askQuestion(index) {
      stepIndex = index;
      var q = QUESTIONS[index];

      appendAiMessage(q.text, {
        step: index,
        onDone: function () {
          renderChoices(q, index);
        }
      });
      renderNav(index);
    }

    function renderChoices(q, index) {
      var existing = answers[q.id];
      var group = document.createElement('div');
      group.className = 'feela-seat-v2-fc__choices';
      group.setAttribute('data-fsv-fc-step', String(index));
      group.setAttribute('role', 'group');
      group.setAttribute('aria-label', q.text);

      q.options.forEach(function (opt) {
        var isSelected = existing && existing.value === opt.value;
        var btn = button('feela-seat-v2-fc__choice' + (isSelected ? ' is-selected' : ''), null, {
          'aria-pressed': isSelected ? 'true' : 'false'
        });
        var labelSpan = document.createElement('span');
        labelSpan.textContent = opt.label;
        btn.appendChild(labelSpan);
        if (isSelected) {
          var check = document.createElement('span');
          check.innerHTML = CHECK_SVG;
          btn.appendChild(check);
        }
        btn.addEventListener('click', function () { selectAnswer(q, opt, index, group); });
        group.appendChild(btn);
      });

      chatLog.appendChild(group);
      scrollLogToBottom();
    }

    function renderNav(index) {
      clear(actionSlot);
      var nav = document.createElement('div');
      nav.className = 'feela-seat-v2-fc__nav';
      if (index > 0) {
        var backBtn = button('feela-seat-v2-fc__nav-link', '前の質問に戻る');
        backBtn.addEventListener('click', function () { goBack(); });
        nav.appendChild(backBtn);
      }
      var restartBtn = button('feela-seat-v2-fc__nav-link', '最初からやり直す');
      restartBtn.addEventListener('click', function () { doRestart(); });
      nav.appendChild(restartBtn);
      actionSlot.appendChild(nav);
    }

    function selectAnswer(question, option, index, group) {
      if (typingLock) return;
      typingLock = true;
      Array.prototype.slice.call(group.querySelectorAll('button')).forEach(function (b) { b.disabled = true; });
      answers[question.id] = option;

      if (group.parentNode) group.parentNode.removeChild(group);
      appendUserMessage(option.label, index);

      var next = index + 1;
      if (next >= QUESTIONS.length) {
        /* 2026-08-29 修正: 6問目回答から結果表示までを2.4〜3.0秒に収めるため、
           最後の質問から分析開始までの間だけは短い間（reduced motionでは0）にする。 */
        clear(actionSlot);
        var toAnalysis = prefersReducedMotion() ? 0 : 500;
        setTimer(function () {
          typingLock = false;
          beginAnalyzing();
        }, toAnalysis);
      } else {
        var delay = prefersReducedMotion() ? 0 : 450;
        setTimer(function () {
          typingLock = false;
          askQuestion(next);
        }, delay);
      }
    }

    /* ---- 前の質問に戻る／最初からやり直す ---- */
    function goBack() {
      if (stepIndex <= 0) return;
      clearTimers();
      typingLock = false;
      var target = stepIndex - 1;
      removeStepsFrom(target);
      askQuestion(target);
    }

    function doRestart() {
      renderStart();
    }

    /* ---- 分析中（AI発言を順番に追加、reduced motionでは演出そのものを省略） ----
       2026-08-29 修正: 6問目回答から結果表示（結果見出しがDOMに現れるまで）を
       合計2.4〜3.0秒に収めるため、4つの分析メッセージはタイプライターを使わず
       全文を即時表示し、メッセージ間は短い間だけにする。質問文のタイプライター
       演出はここでは変更していない（appendAiMessageの通常経路のまま）。 */
    function beginAnalyzing() {
      if (prefersReducedMotion()) {
        renderResult();
        return;
      }
      var idx = 0;
      function nextLine() {
        appendAiMessage(ANALYZING_LINES[idx], { instant: true });
        idx++;
        if (idx < ANALYZING_LINES.length) {
          setTimer(nextLine, 600);
        } else {
          setTimer(renderResult, 300);
        }
      }
      nextLine();
    }

    /* ---- 結果（結果確定→購入エリアへ反映→AI発言＋結果カードの表示） ----
       2026-08-29 修正: 「結果を確定した時点」で購入エリアへ1回だけ反映する。
       結果見出し（結果カード）は、案内メッセージのタイプライター完了を待たず
       同じタイミングで描画する（タイプライターは見た目の演出として続くだけで、
       結果見出しがDOMに現れるまでの時間には影響しない）。 */
    function renderResult() {
      var tier = calcTier(answers);
      var info = TIER_INFO[tier];
      var reco = buildRecommendation(answers);

      applyTierToPurchase(tier);
      var availability = checkAvailability(tier);

      appendAiMessage('ありがとうございます。回答をもとに見ると、あなたには「' + info.name + '」が合いそうです。', {});
      renderResultCard(tier, info, reco, availability);
    }

    function renderResultCard(tier, info, reco, availability) {
      var card = document.createElement('div');
      card.className = 'feela-seat-v2-fc__result-card';

      var tierHeading = document.createElement('p');
      tierHeading.className = 'feela-seat-v2-fc__result-tier';
      tierHeading.tabIndex = -1;
      tierHeading.textContent = info.name;
      card.appendChild(tierHeading);

      var desc = document.createElement('p');
      desc.className = 'feela-seat-v2-fc__result-desc';
      desc.textContent = info.desc + '／' + info.weight;
      card.appendChild(desc);

      var recoEl = document.createElement('p');
      recoEl.className = 'feela-seat-v2-fc__result-reco';
      recoEl.textContent = reco;
      card.appendChild(recoEl);

      var note = document.createElement('p');
      note.className = 'feela-seat-v2-fc__result-note';
      note.textContent = 'この結果は、体重と回答内容をもとにした硬さ選びの目安です。座り心地の好みに合わせて変更できます。';
      card.appendChild(note);

      if (availability.determined && !availability.available) {
        var warn = document.createElement('p');
        warn.className = 'feela-seat-v2-fc__result-warning';
        warn.textContent = '現在選択中の硬さは在庫切れです。別の硬さをお選びください。';
        card.appendChild(warn);
      }

      chatLog.appendChild(card);
      scrollLogToBottom();
      focusWithoutScroll(tierHeading);

      renderResultActions(tier, availability);
    }

    /* 2026-08-29 修正: このボタンはもう硬さを選び直したり変更イベントを起こしたり
       しない。役割は「購入エリアまでスクロールしてフォーカスする」だけ。硬さは
       renderResult()内でapplyTierToPurchase()によりすでに反映済み。在庫切れの
       場合はボタン文言を変え、押しても内容は変えずに購入エリアへ案内するだけにする。
      2026-08-31: SEAT v2はブラック固定になったため、在庫切れ時の文言から
      「カラーを変更する」という案内を外した（カラーは選べないため）。 */
    function renderResultActions(tier, availability) {
      clear(actionSlot);
      if (!availability.determined || availability.available) {
        var applyBtn = button('feela-seat-v2__btn feela-seat-v2__btn--primary', 'おすすめの硬さで注文内容を確認する');
        applyBtn.addEventListener('click', function () { scrollToPurchaseAndFocus(); });
        actionSlot.appendChild(applyBtn);
      } else {
        var changeBtn = button('feela-seat-v2__btn feela-seat-v2__btn--outline', '別の硬さを選ぶ');
        changeBtn.addEventListener('click', function () { scrollToPurchaseAndFocus(); });
        actionSlot.appendChild(changeBtn);
      }
      var resetBtn = button('feela-seat-v2-fc__nav-link', 'もう一度チェックする');
      resetBtn.addEventListener('click', function () { doRestart(); });
      actionSlot.appendChild(resetBtn);
    }

    stage.hidden = false;
    if (fallback) fallback.hidden = true;
    renderStart();

    root._fsvFcClearTimers = clearTimers;
  }

  function scan() {
    document.querySelectorAll('[data-fsv-fc]').forEach(initRoot);
  }

  document.addEventListener('shopify:section:unload', function (event) {
    var root = event.target && event.target.querySelector ? event.target.querySelector('[data-fsv-fc]') : null;
    if (root && root._fsvFcClearTimers) root._fsvFcClearTimers();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan, { once: true });
  } else {
    scan();
  }
  document.addEventListener('shopify:section:load', scan);
})();

/* =====================================================================
   体重選択 → 3つの硬さカード連携（2026-08-29）
   上の「AI硬さアドバイザー」(6問診断)とは状態を一切共有しない独立モジュール。
   選択は既存3カードの見た目（おすすめ/好みでバッジ・トーン）だけを変え、
   購入エリアのvariantには一切触れない。新しいscriptタグは追加していない。
   IntersectionObserver・requestAnimationFrame・scrollリスナー・タイマーは
   追加しない。ルートごとに初期化ガードし、shopify:section:load後も
   二重初期化しない。
   ===================================================================== */
(function () {
  'use strict';

  if (window.__fsvWeightSelectorInitialized) return;
  window.__fsvWeightSelectorInitialized = true;

  var BAND_ORDER = ['under45', 'b45to60', 'b60to75', 'b75to85', 'over85'];
  var BAND_INFO = {
    under45: { main: 'soft', sub: null, text: 'ソフトがおすすめです。' },
    b45to60: { main: 'medium', sub: 'soft', text: 'ミディアムがおすすめ。やわらかめが好みならソフトも。' },
    b60to75: { main: 'medium', sub: null, text: 'ミディアムがおすすめです。' },
    b75to85: { main: 'medium', sub: 'hard', text: 'ミディアムがおすすめ。しっかりめが好みならハードも。' },
    over85: { main: 'hard', sub: null, text: 'ハードがおすすめです。' }
  };

  /* 2026-09-01: 749px以下では、体重を選んだときに硬さカードを
     「おすすめ → 好みで → 残り」の順へ**DOM上で**並べ替える。
     CSSのorderを使わないのは、見た目の順番と読み上げ順・Tab順がずれるため。
     判定（BAND_INFO）には一切手を入れていない。並べ替えは既存要素の移動だけで、
     複製もクローンもしない（ボタンやイベントは作り直されない）。
     画面幅の判定は matchMedia。windowのscroll/resizeリスナーや
     IntersectionObserverは追加していない。 */
  var MOBILE_MQ = window.matchMedia ? window.matchMedia('(max-width: 749px)') : null;
  var activeRoots = [];

  function bindMq(handler) {
    if (!MOBILE_MQ) return;
    if (MOBILE_MQ.addEventListener) MOBILE_MQ.addEventListener('change', handler);
    else if (MOBILE_MQ.addListener) MOBILE_MQ.addListener(handler);
  }

  function unbindMq(handler) {
    if (!MOBILE_MQ) return;
    if (MOBILE_MQ.removeEventListener) MOBILE_MQ.removeEventListener('change', handler);
    else if (MOBILE_MQ.removeListener) MOBILE_MQ.removeListener(handler);
  }

  function initRoot(root) {
    if (root.dataset.fsvWselInitialized === 'true') return;
    root.dataset.fsvWselInitialized = 'true';

    var track = root.querySelector('[data-fsv-wsel-track]');
    var resultEl = root.querySelector('[data-fsv-wsel-result]');
    var opts = Array.prototype.slice.call(root.querySelectorAll('[data-fsv-wsel-opt]'));
    if (!track || !opts.length) return;

    var cards = Array.prototype.slice.call(document.querySelectorAll('[data-fsv-hcard]'));
    var selected = null;

    /* 並べ替え用。originalOrder は「ソフト → ミディアム → ハード」の初期並び。
       grid は3枚のカードだけを直接の子に持つ入れ物。 */
    var grid = cards.length ? cards[0].parentElement : null;
    var originalOrder = cards.slice();

    /* 「3種類の違いを見る」ボタン。体重を選んでいる間だけ
       data-fsv-modal-tab を付け外しする。モーダル側のJSは元から
       この属性を見てタブを選ぶだけなので、モーダルには一切手を入れていない
       （タブを選ぶだけでvariantは変わらない）。 */
    var compareBtn = document.querySelector('[data-fsv-wsel-compare]');

    function setCardState(card, state) {
      if (state) {
        card.setAttribute('data-fsv-hcard-state', state);
      } else {
        card.removeAttribute('data-fsv-hcard-state');
      }
      var mainBadge = card.querySelector('[data-fsv-hcard-badge-main]');
      var subBadge = card.querySelector('[data-fsv-hcard-badge-sub]');
      if (mainBadge) mainBadge.hidden = state !== 'main';
      if (subBadge) subBadge.hidden = state !== 'sub';
    }

    function applyCardStates(bandKey) {
      var info = bandKey ? BAND_INFO[bandKey] : null;
      cards.forEach(function (card) {
        var key = card.dataset.fsvHcard;
        if (!info) {
          setCardState(card, null);
        } else if (key === info.main) {
          setCardState(card, 'main');
        } else if (key === info.sub) {
          setCardState(card, 'sub');
        } else {
          setCardState(card, 'dim');
        }
      });
    }

    /* 749px以下で選択中のときだけ「おすすめ → 好みで → 残り」。
       それ以外（PC・未選択）は必ず元の並びへ戻す。 */
    function desiredOrder() {
      if (!MOBILE_MQ || !MOBILE_MQ.matches || !selected) return originalOrder;
      var info = BAND_INFO[selected];
      if (!info) return originalOrder;
      var main = [];
      var sub = [];
      var rest = [];
      originalOrder.forEach(function (card) {
        var key = card.dataset.fsvHcard;
        if (key === info.main) main.push(card);
        else if (key === info.sub) sub.push(card);
        else rest.push(card);
      });
      return main.concat(sub, rest);
    }

    /* 既存のカード要素をそのまま移動する（複製しない）。
       すでに目的の並びなら何もしないので、無駄なDOM操作は起きない。
       ページのスクロール位置は動かさない（scrollIntoViewは呼ばない）。 */
    function applyOrder() {
      if (!grid) return;
      var target = desiredOrder();
      var current = Array.prototype.slice.call(grid.children).filter(function (el) {
        return el.hasAttribute && el.hasAttribute('data-fsv-hcard');
      });
      var same =
        current.length === target.length &&
        current.every(function (el, i) {
          return el === target[i];
        });
      if (same) return;
      target.forEach(function (card) {
        grid.appendChild(card);
      });
    }

    /* 体重を選んでいる間は、比較モーダルをおすすめの硬さタブで開く。
       未選択に戻したら属性を外し、元の初期タブ動作へ戻す。 */
    function syncCompareTab() {
      if (!compareBtn) return;
      var info = selected ? BAND_INFO[selected] : null;
      if (info) compareBtn.setAttribute('data-fsv-modal-tab', info.main);
      else compareBtn.removeAttribute('data-fsv-modal-tab');
    }

    function clearSelection() {
      selected = null;
      opts.forEach(function (b) {
        b.classList.remove('is-selected');
        b.setAttribute('aria-pressed', 'false');
      });
      track.removeAttribute('data-selected');
      if (resultEl) resultEl.textContent = '';
      applyCardStates(null);
      applyOrder();
      syncCompareTab();
    }

    function select(bandKey) {
      if (selected === bandKey) {
        clearSelection();
        return;
      }
      selected = bandKey;
      var index = BAND_ORDER.indexOf(bandKey);
      track.style.setProperty('--fsv-wsel-index', String(index));
      track.setAttribute('data-selected', 'true');
      opts.forEach(function (b) {
        var isSel = b.dataset.fsvWselOpt === bandKey;
        b.classList.toggle('is-selected', isSel);
        b.setAttribute('aria-pressed', isSel ? 'true' : 'false');
      });
      if (resultEl) resultEl.textContent = BAND_INFO[bandKey].text;
      applyCardStates(bandKey);
      applyOrder();
      syncCompareTab();
      /* 押した体重ボタンにフォーカスを残す。おすすめカードへは移さない。 */
    }

    opts.forEach(function (btn) {
      btn.addEventListener('click', function () {
        select(btn.dataset.fsvWselOpt);
      });
    });

    /* 画面幅がモバイル↔PCをまたいだときだけ並べ替え直す。
       ルートごとに1回だけ登録し、section unload で解除できるよう控えておく。 */
    var onBreakpointChange = function () {
      applyOrder();
    };
    bindMq(onBreakpointChange);
    /* 幅の切り替え処理を外から呼べるようにしておく（検証用の入口。
       teardown と同じくルート要素に持たせるだけで、リスナーは増やさない）。 */
    root.__fsvWselApplyOrder = applyOrder;
    root.__fsvWselTeardown = function () {
      unbindMq(onBreakpointChange);
      root.__fsvWselApplyOrder = null;
    };
    if (activeRoots.indexOf(root) === -1) activeRoots.push(root);

    root.hidden = false;
  }

  function scan() {
    document.querySelectorAll('[data-fsv-wsel]').forEach(initRoot);
  }

  /* セクションが外されたら、そのルートのmatchMediaリスナーを解除する。
     document側のリスナーはこのモジュール全体で1組だけ（先頭のガードで二重登録しない）。 */
  function releaseDetachedRoots() {
    activeRoots = activeRoots.filter(function (root) {
      if (document.contains(root)) return true;
      if (typeof root.__fsvWselTeardown === 'function') root.__fsvWselTeardown();
      root.__fsvWselTeardown = null;
      return false;
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan, { once: true });
  } else {
    scan();
  }
  document.addEventListener('shopify:section:load', function () {
    releaseDetachedRoots();
    scan();
  });
  document.addEventListener('shopify:section:unload', releaseDetachedRoots);
})();
